"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHEEL_MAX_SCALE_RATIO = exports.MIN_SCALE = exports.MAX_SCALE = exports.BASE_SCALE_RATIO = void 0;

/** Minimum scale */
var MIN_SCALE = 1;
/** Maximum Scale */

exports.MIN_SCALE = MIN_SCALE;
var MAX_SCALE = 50;
/** Scale the ratio base */

exports.MAX_SCALE = MAX_SCALE;
var BASE_SCALE_RATIO = 1;
/** The maximum zoom ratio when the mouse zooms in, adjustable */

exports.BASE_SCALE_RATIO = BASE_SCALE_RATIO;
var WHEEL_MAX_SCALE_RATIO = 0.2;
exports.WHEEL_MAX_SCALE_RATIO = WHEEL_MAX_SCALE_RATIO;


//////////////////
// WEBPACK FOOTER
// ./~/rc-image/lib/previewConfig.js
// module id = 901
// module chunks = 0